// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2_cssnano@5.1.15_postcss@8.4.47__postcss@8.4.47_/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2_cssnano@5.1.15_postcss@8.4.47__postcss@8.4.47_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.application-list[data-v-940679d2] {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;

  max-width: 100%;
  width: 100%;
  padding: 16px;
}
.application[data-v-940679d2] {
  flex: 0 0 33%;
  display: block;
  overflow: hidden;
  overflow-wrap: break-word;
  position: relative;
  padding: 0;
}
.application__button[data-v-940679d2] {
  display: flex;
  flex-direction: column;
  align-items: center;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
